'use client'

import classNames from 'classnames'
import React, { useState } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'

import { ReactComponent as HeroLogo } from '~/assets/hero-logo.svg'
import RichText from '~/components/rich-text'
import Title from '~/components/title'
import SliderNavigation from '~/layouts/shared/slider-navigation'
import { animate } from '~/utils/animation'

import { IHeroSlideItems } from './block-main-hero'
import MainHeroSliderItem from './main-hero-slide-item'

interface Props extends React.PropsWithChildren {
  items: IHeroSlideItems[]
}

const MainHeroSlider: React.FC<Props> = ({ items, children }) => {
  const [slider, setSlider] = useState<SwiperClass>()
  const [isBackDisable, setBackDisable] = useState(true)
  const [isNextDisable, setNextDisable] = useState(false)
  const [isPaginationEnabled, setPaginationEnabled] = useState(true)

  const paginationName = 'slider-pagination-main-hero'

  return (
    <div className="w-full">
      <Swiper
        slidesPerView={1}
        modules={[Pagination]}
        className={classNames('!overflow-visible', {
          'cursor-grab active:cursor-grabbing': items.length > 1,
        })}
        pagination={{
          el: '.' + paginationName,
          clickable: true,
          renderBullet: (i, className) => {
            return '<span class="' + className + '"></span>'
          },
        }}
        onInit={(swiper) => {
          setSlider(swiper)
          setPaginationEnabled(!swiper.isLocked)
        }}
        onSlideChange={(swiper) => {
          setBackDisable(swiper.isBeginning)
          setNextDisable(swiper.isEnd)
          setPaginationEnabled(!swiper.isLocked)
        }}
        autoHeight={true}
      >
        {items.map((item, index) => (
          <SwiperSlide key={`main-hero-item-${item.id}`}>
            <MainHeroSliderItem
              titleTag={index === 0 ? 'h1' : 'h2'}
              {...item}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        className={classNames(
          'mt-10 md:mt-8 1.5xl:mt-14 container-small pagination-white flex flex-col-reverse gap-8 items-center md:grid md:grid-cols-3',
          animate(3)
        )}
      >
        {isPaginationEnabled && (
          <SliderNavigation
            pagination={paginationName}
            onClickBack={() => slider.slidePrev()}
            onClickNext={() => slider.slideNext()}
            isBackDisable={isBackDisable}
            isNextDisable={isNextDisable}
            defaultSpacing={false}
          />
        )}
        {children}
      </div>
    </div>
  )
}

export default MainHeroSlider
